import stateData from 'datasets-us-states-abbr';

export default [...stateData, 'DC'].sort();
